export const deleteLeaderBoardEntries = () => ({
    type: "DELETE_LEADERBOARD_ENTRIES"
})

export const setLeaderBoardEntries = (entries) => ({
    type: "SET_LEADERBOARD_ENTRIES",
    entries
})